<ng-container thr-parent-form>
    <thr-contract-form-participant-natural-person [client]="client" [isFirst]="true"></thr-contract-form-participant-natural-person>
</ng-container>
